<template>
  <div>

    <Head style="backgroundColor: #fff;"></Head>
    <navigationbar cid="1"></navigationbar>
    <div class="firstdiv"></div>
    <div class="content flex flex-direction align-center">
      <div class="firstdiv"></div>

      <div class="flex flex-direction width "
           style="height: auto; margin-top: 0.4rem ">
        <!-- <div class="top flex flex-direction"> -->

        <!-- <div class="flex classify align-center font-size-24">

            <img src="../../assets/tab/mnue.png"
                 alt="">
            <p class=" font-color-0cb"
               style="margin-left:0.22rem;margin-right:0.22rem">活动类型</p>

            <p @click="thirdCheck(index)"
               class="choose cursor-pointer"
               :class="index == thirdIndex?'check':'uncheck'"
               v-for="(item, index) in thirdClassify"
               :key="index">
              {{item}}
            </p>
          </div> -->
        <!-- <div class="flex last align-center font-size-24">

            <img src="../../assets/tab/mnue.png"
                 alt="">
            <p class=" font-color-0cb"
               style="margin-left:0.22rem;margin-right:0.22rem">活动分类</p>

            <p @click="fourCheck(index)"
               class="choose cursor-pointer"
               :class="index == fourIndex?'check':'uncheck'"
               v-for="(item, index) in fourClassify"
               :key="index">
              {{item}}
            </p>
          </div> -->
        <!-- </div> -->
        <div class="bottom  flex-direction flex">
          <div class="itemdiv">
            <div @click="toDes(item.Id)"
                 v-for="(item, index) in dataList"
                 :key="index"
                 class="item cursor-pointer">
              <img :src="item.ImageUrl" />
              <p class=" font-size-24 font-color-22 text-line1"
                 style="margin-left:.26rem">
                {{item.Intro}}</p>
              <div class=" font-size-18 font-color-a7 "
                   style="margin: .25rem 0 0 .26rem">
                {{item.StartTime}}</div>
              <div class="morel"
                   :class="item.Status==1?'check':'uncheck'">
                {{item.Status==1?"进行中":"已结束"}}
              </div>
            </div>
          </div>
          <div style="margin: 0.5rem auto ">

            <paginate v-if="totalPage>0"
                      :pages="totalPage"
                      @jump="jumpPage"
                      :groups="totalPage>5?5:totalPage"></paginate>
          </div>
        </div>
      </div>
      <!-- <div class="seconddiv"></div> -->
    </div>
  </div>
</template>

<script>
import common from "@/utils/common.js";
export default {
  data () {
    return {

      thirdIndex: 0,
      fourIndex: 0,
      pageIndex: 1,
      totalPage: 0,
      thirdClassify: ['全部', '线上', '线下', '最多分享'],
      fourClassify: ['全部', '英语', '环保'],
      dataList: [],
    };
  },



  mounted () {
    this.getActivityList()
  },
  methods: {

    jumpPage (page) {
      this.pageIndex = page
      this.getActivityList();
    },
    toDes (id) {
      this.$router.push({
        name: 'activitydes',
        params: {
          id: id
        }
      })
    },
    getActivityList () {
      this.getRequest('api/v1/Activity/List', {
        Type: 0,
        PageIndex: this.pageIndex,
        PageSize: 15,

      }).then(data => {
        console.log(data);
        if (data.IsSuccess) {
          this.dataList = data.Data.DataList
          this.totalPage = data.Data.TotalPage;

        }
      })
    },

    thirdCheck (index) {
      if (this.thirdIndex != index) {
        this.thirdIndex = index;
      }
    },
    fourCheck (index) {
      if (this.fourIndex != index) {
        this.fourIndex = index;
      }
    },

  },
};
</script>

<style scoped>
.firstdiv {
  background: url("../../assets/icon-bg.jpg");
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  /* background-size: 100% auto; */
  position: fixed;
  /* height: 5.05rem; */
  top: 0;
  left: 0;
  z-index: -1;
  background-color: #cbfeee;
}

.content {
  padding-bottom: 0.56rem;
}

.seconddiv {
  background-size: 100% auto;
  margin-top: -3.5rem;
  background: url("../../assets/video/icon-video-bottombg.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: bottom;
  width: 100%;
  height: 5.97rem;
}
.top {
  z-index: 3;
  min-height: 1.86rem;
  padding: 0 0.44rem;
  background: #ffffff;
  box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.35);
  border-radius: 0.16rem;
}
.top .classify {
  padding: 0.24rem 0;
  border-bottom: 1px solid rgba(211, 211, 211, 0.5);
  height: 0.93rem;
}
.top .last {
  height: 0.93rem;
}
.choose {
  height: 0.45rem;
  line-height: 0.45rem;
  min-width: 1.37rem;
  text-align: center;
  border-radius: 0.25rem;
}
.choose:hover {
  color: #ffffff;
  background: #ffcb05;
}

.check {
  color: #ffffff;
  background: #ffcb05;
}
.uncheck {
  color: #1b1b1b;
  background: #ffffff;
}

.bottom {
  width: 100%;
  margin-top: 0.34rem;
  z-index: 3;
  background: #ffffff;
  box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.35);
  border-radius: 0.16rem;
}
.bottom .itemdiv {
  flex-wrap: wrap;
  display: flex;
  flex-grow: 1;
  min-height: 9.82rem;
  align-content: flex-start;
}

.item {
  width: 4.1rem;
  height: 4.04rem;
  margin-left: 0.44rem;
  margin-top: 0.42rem;
  background: #ffffff;
  box-shadow: 0px 0px 0.38rem 0px rgba(188, 188, 188, 0.35);
  border-radius: 0.1rem;
  display: flex;
  position: relative;
  overflow: hidden;
  flex-direction: column;
}

.item img:hover {
  transform: scale(1.1);
  transition: all 0.3s;
}

.item img {
  width: 4.1rem;
  height: 2.72rem;

  position: relative;
  display: block;
  overflow: hidden;
  transition: all 0.3s;
}

.item p {
  width: 3.5rem;
  font-size: 0.24rem;
  margin-top: 0.26rem;
  line-height: 0.3rem;
  overflow: hidden;
}
.item p:hover {
  color: #0cb4a2;
}
.item .morel {
  min-width: 0.8rem;
  height: 0.3rem;
  padding: 0 0.2rem;
  position: absolute;
  align-items: center;
  font-size: 0.2rem;
  right: 0rem;
  top: 2.42rem;
  color: #ffffff;
  z-index: 2;
}
.item .morel .check {
  background: #ffcb05;
}
.item .morel .uncheck {
  background: #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/view/activity/activity.vue